<template>
    <div>
        <v-container class="content-container py-lg-8 px-0" :style="phoneOnly ? 'padding: 0!important' : ''" :class="{'full-height surface': phoneOnly}">
            <v-card flat class="inbox-wrapper d-flex align-stretch" color="surface" :class="{'bordered': pcOnly}">
                <v-row class="pa-0 ma-0" style="max-width: 100%;">
                    <v-col cols="12" md="5" lg="4" class="navigate-aside overflow-y-auto e-scrollbar surface pa-0 ma-0" :class="{'side-border': pcOnly}">
                        <v-toolbar v-if="pcOnly" flat class="w-full px-0" color="transparent" height="55">
                            <v-toolbar-title class="medium-text">البريد الوارد</v-toolbar-title>
                            <v-chip v-if="unreadInboxCount" color="ebadge" dark small class="ms-2" style="height: 21px">
                                <b class="default-fonts" style="font-size: 13px; line-height: 1;">{{unreadInboxCount}}</b>
                            </v-chip>
                        </v-toolbar>
                        <v-list two-line class="surface pa-lg-0">
                            <template v-for="conversation in sortedConversations" >
                                <conversation-list-item :key="conversation.id" :conversation="conversation" :active="activeConversation === conversation.id" @open="openConversation(conversation)" />
                                <v-divider inset :key="'d-' + conversation.id" style="border-color: rgba(0,0,0, 0.05)"></v-divider>
                            </template>
                        </v-list>
                    </v-col>
                    <v-col v-if="pcOnly" cols="12" md="7" lg="8" class="pa-0 ma-0" :class="{'surface2': !activeConversationItem}">
                        <conversation v-if="activeConversationItem" :conversation="activeConversationItem" style="height: 100%" @closeConversation="openCloseDialog = true" />
                    </v-col>
                </v-row>
            </v-card>
            <v-dialog v-if="phoneOnly" v-model="showConversationDialog" :transition="'slide-' + (showConversationDialog ? 'right' : 'left')" fullscreen fluid scrollable>
                <v-card flat style="height: 100%; border-radius: 0!important" >
                    <v-toolbar flat style="border-bottom: 1px solid rgba(0,0,0, .1)" :class="{'mt-7': statusBarOverlay}">

                        <v-btn icon color="muted" @click="closeConversationDialog" style="margin: 0 -10px!important">
                            <v-icon :size="pcOnly ? 21 : 24">mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="activeConversationItem" class="px-3 medium-text">{{activeConversationItem.title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <conversation v-if="activeConversationItem" :conversation="activeConversationItem" style="height: 100%" @closeConversation="openCloseDialog = true" />
                </v-card>
            </v-dialog>

            <action-dialog v-model="openCloseDialog" vuex-action="closeConversation" :title="`غلق المحادثة`" :data="{id: activeConversation}" button-text="تأكيد" button-color="strong-text">
                عندما تكون المحادثة مغلقة لن يتم السماح بإرسال رسائل جديدة، فهل أنت متأكد من إغلاقها؟
            </action-dialog>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import ConversationListItem from './conversation-list-item'
import Conversation from './Conversation'

export default {
    name: 'Inbox',
    components: {
        ConversationListItem,
        Conversation,

    },
    data(){
        return {
            activeConversation: null,

            showConversationDialog: false,
            openCloseDialog: false,

            newMessage: '',
            loading: false,

            /* conversations: [
                {
                    id: 1,
                    title: 'Shaikh Ahmed dsg dsg sdgdsg sdg',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 2,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 3,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 4,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 5,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 6,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 7,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
                {
                    id: 8,
                    title: 'Shaikh Ahmed',
                    avatar: 'http://riwaqalazhar.api/storage/courses/Understanding_the_Quran_mmCv9.jpg',
                    last_message: {
                        id: 1,
                        text: "Ok That's great!",
                        created_at: '',
                        created_at_timestamp: 1636391319799,
                    },
                },
            ], */
        };
    },
    computed:{
        ...GlobalComputed,
        activeConversationItem(){
            return this.activeConversation ? this.conversations.find(c=>c.id === this.activeConversation) : null;
        },
        conversations(){
            return this.$store.state.inboxModule.conversations;
        },
        sortedConversations(){
            let conversations = this.conversations;
            conversations = conversations.sort((a, b)=>{
                let aTimestamp = a.last_message ? a.last_message.created_at_timestamp : a.created_at_timestamp;
                let bTimestamp = b.last_message ? b.last_message.created_at_timestamp : b.created_at_timestamp;
                return bTimestamp - aTimestamp;
            });

            return conversations;
        },
        statusBarOverlay(){
            return this.platform === 'ios';
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        activeConversation(active){
            if (active){
                this.showConversationDialog = true;
            }
        }
    },
    methods:{
        ...GlobalMethods,
        loadConversations(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getConversations').then(()=>{
                    this.loading = false;
                    this.checkQueryParams();
                }).catch(e=>{
                    this.showMsg('حدثت مشكلة أثناء الاتصال', 'error');
                    this.loading = false;
                })
            }
        },
        openConversation(conversation){
            if (this.activeConversation !== conversation.id){
                this.activeConversation = conversation.id;
            }else{
                // if clicked on active conversation, mark it as seen
                this.updateSeen(conversation);
            }
        },
        checkQueryParams(){
            const conversation_id = this.$route.query.conversation;
            if (conversation_id){
                const conversation = this.conversations.find(c=>c.id === parseInt(conversation_id));
                if (conversation){
                    this.openConversation(conversation);
                }
            }
        },
        updateSeen(conversation){
            if (!conversation.seen){
                this.$store.commit('UPDATE_CONVERSATION_DATA', {id: conversation.id, seen: true});
            }
        },
        closeConversationDialog(){
            this.showConversationDialog = false;
            window.setTimeout(()=>{
                this.activeConversation = null;
            }, 500);
        }
    },
    mounted(){
        if (!this.conversations || this.conversations.length === 0){
            this.loadConversations();
        }
        if (this.capRunning){
            document.addEventListener('backbuttonclicked', ()=>{
                if (this.showConversationDialog){
                    this.closeConversationDialog();
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
    .inbox-wrapper{
        overflow: hidden;
        @media(min-width: 768px){
            min-height: 80vh;
            max-height: 80vh;
            // box-shadow: 0 1px 1px 0 rgba(#000,.06),0 2px 5px 0 rgba(#000,.2)!important;
        }
        @media(max-width: 768px){
            // min-height: 90vh;
        }
        .navigate-aside{
            height: 100%;
            &.side-border{
                border-right: 1px solid rgba(#000, 0.1)!important;
                
                &.is--dark{
                    border-right: 1px solid rgba(#fff, 0.1)!important;
                }
            }
        }
        .v-toolbar{
            border-bottom: 1px solid rgba(#000, 0.05)!important;
        }
    }
    .v-application--is-rtl{
        .navigate-aside{
            &.side-border{
                border-right: none!important;
                border-left: 1px solid rgba(#000, 0.1)!important;

                &.is--dark{
                    border-left: 1px solid rgba(#fff, 0.1)!important;
                }   
            }
        }
    }
    .full-height{
        height: 90vh;
    }
</style>